import {gql} from "@apollo/client";

export const GET_JOB_STEP_RUN_DETAILS = gql`
	query GetJobStepRunDetails(
		$jobStepRunId: Int
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: [JobStepRunDetailFilterInput!]
		$order: [JobStepRunDetailSortInput!]
	) {
		jobStepRunDetails(
			before: $before
			after: $after
			first: $first
			last: $last
			where: { jobStepRun: {id: { eq: $jobStepRunId } }, and: $where }
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
		        id
				failed
				succeeded
				start
				finish
				description
			    logEntries {
					id
					logLevel
					timeStamp
					message
				}
			}
		}
	}
`;
